(function () {
    class ListTargetSourcesComponent {
        constructor(
            $scope,
            $state,
            $uibModal,
            NgTableParams,
            NgTableEventsChannel,
            CampaignDesignerService,
            PermissionService,
            LocalisationService,
            ErrorService
        ) {
            this.scope = $scope;
            this.scope.busyLoading = true;
            this.state = $state;
            this.modal = $uibModal;
            this.errorService = ErrorService;
            this.campaignDesignerService = CampaignDesignerService;
            this.permissionService = PermissionService;
            this.ngTableParams = NgTableParams;
            this.userContext = this.permissionService.userContext;
            $scope.statuses = Object.entries(Dashboard.Models.Lookups.CampaignTargetSourceStatuses).map(([key, value]) => ({key,value}));
            $scope.types = Object.entries(Dashboard.Models.Lookups.CampaignLevels).map(([key, value]) => ({key,value}));
            $scope.filter = {};
            this.localisationService = LocalisationService;
            NgTableEventsChannel.onPagesChanged(this.scrollToTop.bind(this), $scope);
            this.initialise();
        }

        initialise() {
            this.checkUserAccessToCampaignDesigner();
            this.contextName = this.userContext.getCurrentContextName();
            this.setFilter();

            this.targetSourcesTableParams = new this.ngTableParams(
                {
                    filterDelay: 300,
                }, {
                    getData: async (params) => {
                        try {
                            this.scope.busyLoading = true;
                            const { page, count } = params.url();
                            const start = (page * count) - count;
                            const result = await this.campaignDesignerService.getTargetSourcesForFilter(
                                count,
                                start,
                                this.scope.filter);
                            const { data } = result;
                            Dashboard.helpers.tableHelper.useCount(
                                params,
                                data.TotalCount);
                            return data.CampaignTargetSources.map(x => {
                                x.TypeName = this.scope.types.find(y => y.value === x.CampaignLevelId).key;
                                x.StatusName = this.scope.statuses.find(s => s.value === x.StatusId).key;
                                return x;
                            });
                        } catch (e) {
                            this.errorService.showError("An error occurred when trying to load target sources", e);
                        } finally {
                            this.scope.busyLoading = false;
                        }
                    }
                });
        };

        setFilter() {
            this.scope.filter.BrandId = this.userContext.BrandId;
            this.scope.filter.Name = "";
            this.scope.filter.Type = Dashboard.Models.Lookups.CampaignLevels.All;
            this.scope.filter.Status = Dashboard.Models.Lookups.CampaignTargetSourceStatuses.All;
        }

        filterTargetSources() {
            this.targetSourcesTableParams.reload();
        }

        scrollToTop() {
            document.querySelector("body")
                .scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                });
        }

        formatDate(date) {
            return this.localisationService.formatDateShort(date);
        }

        checkUserAccessToCampaignDesigner() {
            const { Permissions } = Dashboard.Models.Lookups;
            if (!this.permissionService.doesUserHavePermissionForContext(Permissions.CampaignDesignerAccess)) {
                this.permissionService.navigateToAccessDenied();
            }
        };

        testTargetSource(targetSource) {
            const modalTemplateUrl = "components/campaigndesigner/targetsources/testtargetsource/test-target-source-modal.678f3f80.html";
            this.modal.open({
                animation: true,
                templateUrl: modalTemplateUrl,
                controller: "TestTargetSourceModalController",
                size: "lg",
                backdrop: "static",
                resolve: {
                    proceed: () => () => {},
                    failed: () => () => {},
                    source: () => targetSource.Source,
                    brandId: () => this.userContext.BrandId,
                    testStoreId: () => targetSource.TestStoreId
                }
            });
        }

        addTargetSource() {
            this.state.go(".add", {
                brandId: this.userContext.BrandId,
            });
        }

        manageTargetSource(targetSource) {
            this.state.go(".edit", {
                id: targetSource.Id,
                brandId: this.userContext.BrandId,
            });
        }
    }

    angular
        .module("dashboard")
        .component("listTargetSources",
            {
                templateUrl: "components/campaigndesigner/targetsources/list-target-sources.ed4bf7c5.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$state",
                    "$uibModal",
                    "NgTableParams",
                    "ngTableEventsChannel",
                    "CampaignDesignerService",
                    "PermissionService",
                    "LocalisationService",
                    "ErrorService",
                    ListTargetSourcesComponent
                ]
            });
})();
